module.exports = __webpack_public_path__ + "img/create_product_from_report.b3c806ae.svg";